// extracted by mini-css-extract-plugin
export var content = "Content-module--content--+92iU";